/* --------------------------------
[JSファイルの説明]
・gulpで scripts.json の libs の各ファイルを連結し、 /js/libs.js に書き出している
・gulpで scripts.json の scripts の各ファイルを連結＆圧縮し、 /js/scripts.js に書き出している
・HTMLでは上記の libs.js と scripts.js を読み込んでいる
・もしもgulpの環境が無くて更新が困難な場合は、書き出したJSは無視して scripts.json の各ファイルをHTMLで直接読み込んでも動作は可能
-------------------------------- */

// スクロールバーを除いたウィンドウ幅をCSSのカスタムプロパティに設定
const setVw = function () {
  const vw = document.documentElement.clientWidth;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}
window.addEventListener('DOMContentLoaded', setVw);
window.addEventListener('resize', setVw);

//aタグ スムーススクロール
$(function () {
  $('a[href^="#"]').click(function () {
    var speed = 500;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;

    position -= $('.l-header').innerHeight() + 20;
    
    $("html, body").animate({ scrollTop: position }, speed, "swing");
    return false;
  });
});

//スライダー
$(function () {
  $('.home-kv__slick').each(function (index, el) {
    const $slider = $(this);

    $slider.slick({
      autoplay: true,
      autoplaySpeed: 3000,
      fade: true,
      speed: 1000,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      arrows: false,
      dots: false
    });
  });
});

//フェード
$(function () {
  var fade = $('.u-fade, .js-fadeAni');

  fade.each(function (index, el) {
    var t = $(this);

    setTimeout(function () {
      $(window).on('resize scroll', function (event) {
        run();
      });

      run();
    }, 200);

    function run() {
      var winT = $(window).scrollTop();
      var winH = $(window).innerHeight();
      var winB = winT + winH;
      var tT = t.offset().top;
      var tH = t.innerHeight();
      var tB = tT + tH;

      var pointH = tT + 50;
      var pointSc = winB;
      var pointD = 200;

      var h = t.attr('data-fade-h');
      if (h) {
        pointH = tT + tH * h / 100;
      }

      var sc = t.attr('data-fade-sc');
      if (sc) {
        pointSc = winT + winH * sc / 100;
      }

      var d = t.attr('data-fade-delay');
      if (d) {
        pointD = d;
      }

      if (pointH < pointSc) {
        setTimeout(function () {
          t.addClass('is-fade');
          next();
        }, pointD);
      }
    }

    function next() {
      var nextStr = t.attr('data-fade-next-target');
      if (nextStr) {
        var nextArr = nextStr.split(' ');
        if (nextArr) {
          for (var i = 0; i < nextArr.length; i++) {
            var next = nextArr[i];
            var nextTar = $('[data-fade-next-id="' + next + '"]');
            if (nextTar[0]) {
              var nextDelay = t.attr('data-fade-next-delay');
              var delay = 200;
              if (nextDelay) {
                delay = parseInt(nextDelay);
              }

              var nextStep = t.attr('data-fade-next-step');
              var step = 200;
              if (nextDelay) {
                step = delay;
              }
              if (nextStep) {
                step = parseInt(nextStep);
              }

              nextTar.each(function (index, el) {
                var t2 = $(this);
                var step2 = step * index + delay;

                setTimeout(function () {
                  t2.addClass('is-fadeNext');
                  t2.attr('data-test', step2);
                }, step2);
              });
            }
          }
        }
      }
    }
  });
});
  
$(function(){
  $(window).on('scroll', function () {
    if ($(this).scrollTop() > 10) {
      $('.l-header').addClass('is-sc');
    } else {
      $('.l-header').removeClass('is-sc');
    }
  });
});

$(function(){
  $('.p-hd__menu button').each(function (index, element) {
    const $menu = $(this);
    const $nav = $('.p-hd__navSP');
    const $hd = $('.l-header');
    const $link = $nav.find('a');

    $menu.on('click', function () {
      $menu.toggleClass('is-on');
      $nav.toggleClass('is-on');
      $hd.toggleClass('is-openMenu');
    });

    $link.on('click', function () {
      $menu.removeClass('is-on');
      $nav.removeClass('is-on');
      $hd.removeClass('is-openMenu');
    });
  });
});

$(function(){
  $('.home-kv__btns').each(function (index, element) {
    const $btns = $(this);
    const $sec = $('.home-about');
    const $fixBnr = $('.home-fixbnr');
    const $fixBnrClose = $fixBnr.find('button');

    run();
    $(window).on('scroll', function () {
      run();
    });

    function run() {
      if($(window).scrollTop() + $(window).innerHeight() > $sec.offset().top) {
        $btns.addClass('is-on');
        $fixBnr.addClass('is-on');
      } else {
        $btns.removeClass('is-on');
        $fixBnr.removeClass('is-on');
      }
    }

    $fixBnrClose.on('click', function () {
      $fixBnr.addClass('is-hide');
    });
  });
});

$(function(){
  $('.home-voices__itemsWrap').each(function (index, element) {
    const $root = $(this);
    const $con = $('.simplebar-content-wrapper');
    const $prev = $('.home-voices__prev');
    const $next = $('.home-voices__next');

    $prev.on('click', function () {
      $con.animate({
        scrollLeft: '-=306'
      }, 400);
    });

    $next.on('click', function () {
      $con.animate({
        scrollLeft: '+=306'
      }, 400);
    });

    $con.on('scroll', function () {
      const scrollLeft = $(this).scrollLeft();
      const maxScrollLeft = this.scrollWidth - this.clientWidth;

      $prev.removeClass('is-disabled');
      $next.removeClass('is-disabled');

      console.log(scrollLeft);
      
      if (scrollLeft <= 0) {
        $prev.addClass('is-disabled');
      } else if (scrollLeft >= maxScrollLeft - 2) {
        $next.addClass('is-disabled');
      }
    });
  });
});

$('.home-con__disabledNext button').each(function (index, element) {
  const $btn = $(this);
  const $next = $btn.parent().next();

  $btn.on('click', function () {
    $btn.hide();
    $next.fadeIn(400);
  });
});

// $(function(){
//   const $kv = $('.home-kv');
//   const $fixBnr = $('.home-fixbnr');

//   if (!$kv.length || !$fixBnr.length) return;

//   function toggleFixBnr() {
//     const kvBottom = $kv.offset().top + $kv.outerHeight();
//     const viewportBottom = $(window).scrollTop() + $(window).innerHeight();

//     $fixBnr.toggleClass('is-on', viewportBottom > kvBottom);
//   }

//   toggleFixBnr();
//   $(window).on('scroll resize', toggleFixBnr);
// });

